<template>
  <myhead @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <MyInvestmentModule :fn="pay"></MyInvestmentModule>
  <PayDialog v-model:showPopup="showPopup" :amount="amount" :nextFn="nextFn"></PayDialog>
</template>
<script setup>
import PayDialog from "@/components/PayDialog.vue";
import MyInvestmentModule from "./components/MyInvestmentModule.vue";
import { ref } from "vue";
import { showToast } from 'vant';
import { useRoute } from "vue-router";
import { invest, payApi } from "@/api/culture.js";



const route = useRoute();
const { query } = route;

const showPopup = ref(false)

//支付props
const amount = ref()
//提交支付
const nextFn = async (val, typeid) => {
  // console.log(val, typeid);
  if (!query.id || !query.cateId) {
    showToast("数据参数不全")
    return;
  }
  const data = {
    id: query.id,
    cate_id: query.cateId,
    amount: val
  }
  const investData = await invest(data);
  if (investData.errcode === 1) {
    const no = investData.data.no
    const data = {
      no: no,
      typeid: typeid,
      return_url: location.origin + "/#/culture/cate" + query.cateId + "?id=" + query.id //返回url参数payresult=1&id=256&cateid=2
    }
    const payData = await payApi(data)
    window.open(payData.data.info)
  }
}

const pay = (val) => {
  if (!val || val === "undefined" || val === null) {
    showToast('请输入金额');
    return;
  }
  amount.value = val;
  showPopup.value = true;
}
</script>
